import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  border: {
    borderTop: `${theme.tokens.border.s}px solid ${theme.tokens.colors.stroke.primary}`,
  },
}));
